import CodeBlock from '../components/CodeBlock';
import PlanBadge from '../components/PlanBadge';

export default function Features() {
  return (
    <>
      <section id="features" className="mb-16">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">Advanced Features</h2>
        <p className="text-gray-700 mb-8">
          Snaptura provides powerful features to customize and control your screenshots.
        </p>
      </section>

      <section id="blocking" className="mb-16">
        <div className="flex items-center gap-3 mb-4">
          <h3 className="text-2xl font-bold text-gray-900">Block Ads & Cookie Banners</h3>
          <PlanBadge plan="growth" />
        </div>
        <p className="text-gray-700 mb-6">
          Automatically block advertisements, tracking scripts, and cookie consent banners
          for cleaner screenshots. Available on Growth and Pro plans.
        </p>
        <CodeBlock section="blocking" />
      </section>

      <section id="darkmode" className="mb-16">
        <div className="flex items-center gap-3 mb-4">
          <h3 className="text-2xl font-bold text-gray-900">Dark Mode</h3>
          <PlanBadge plan="free" />
        </div>
        <p className="text-gray-700 mb-6">
          Enable dark mode for websites that support it. Available on all plans.
        </p>
        <CodeBlock section="darkmode" />
      </section>

      <section id="hide" className="mb-16">
        <div className="flex items-center gap-3 mb-4">
          <h3 className="text-2xl font-bold text-gray-900">Hide Elements</h3>
          <PlanBadge plan="growth" />
        </div>
        <p className="text-gray-700 mb-6">
          Hide specific elements using CSS selectors. Available on Growth and Pro plans.
        </p>
        <CodeBlock section="hide" />
      </section>

      <section id="customCSS" className="mb-16">
        <div className="flex items-center gap-3 mb-4">
          <h3 className="text-2xl font-bold text-gray-900">Custom CSS</h3>
          <PlanBadge plan="growth" />
        </div>
        <p className="text-gray-700 mb-6">
          Inject custom CSS to modify the page appearance. Available on Growth and Pro plans.
        </p>
        <CodeBlock section="customCSS" />
      </section>

      <section id="customJS" className="mb-16">
        <div className="flex items-center gap-3 mb-4">
          <h3 className="text-2xl font-bold text-gray-900">Custom JavaScript</h3>
          <PlanBadge plan="growth" />
        </div>
        <p className="text-gray-700 mb-6">
          Execute custom JavaScript before capturing the screenshot. Available on Growth and Pro plans.
        </p>
        <CodeBlock section="customJS" />
      </section>
    </>
  );
}